<template>
    <v-container fluid v-if="activeProject">
        <v-card class="mb-3">
            <v-card-text>
                <div class="title mb-3">{{$t('settings')}}</div>
                <v-form ref="form" @submit="submit" v-model="formValid">
                    <v-layout>
                        <v-text-field
                            v-model="stepName"
                            label="Step name"
                            class="form-text"
                            :disabled="!activeProject.user_has_role"
                        ></v-text-field>
                        <v-btn type="submit" color="primary" class="text-capitalize" :disabled="!activeProject.user_has_role">{{$t('save')}}</v-btn>
                    </v-layout>
                </v-form>
                <v-layout align-center row wrap mt-3>
                    <v-text-field
                        disabled
                        :value="activeProject.token"
                        :rules="formRules.required"
                        label="Campaign token"
                        class="form-text"
                    ></v-text-field>
                    <v-btn type="submit" color="primary" @click="copyToClipboard" class="text-capitalize">{{$t('copy')}}</v-btn>
                </v-layout>
                <v-divider class="my-3"></v-divider>
                <v-btn @click="deleteCampaign" class="text-capitalize" :disabled="!activeProject.user_has_role">{{$t('deleteThisCampaign')}}</v-btn>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
import FormMixin from '@/mixins/FormMixin'
import DialogPromiseMixin from '@/mixins/DialogPromiseMixin'
import ConfigService from '@/services/config.serivices'
import ProjectService from '@/services/project.service'

export default {
    name: 'Settings',
    mixins: [FormMixin, DialogPromiseMixin],
    data () {
        return {
            stepName: ''
        }
    },
    computed: {
        ...mapState({
            activeProject: state => state.user.activeProject
        })
    },
    methods: {
        copyToClipboard () {
            this.$utils.copyToClipboard(this.activeProject.token, this.$t('copiedToClipboard', ['token']))
        },
        submitValidForm () {
            ConfigService.configStepName(this.stepName, this.$t('saveStepNameSuccess'))
        },
        deleteCampaign () {
            this.$appService.confirm(
                this.$t('confirmDeleteItem', { item: this.$t('campaign') })
            ).then(() => {
                ProjectService.deleteProject(this.activeProject.id).then(
                    () => {
                        this.$router.push('/dashboard')
                    },
                    this.$appService.handleRequestError(this.$t('actionFailed', {
                        action: this.$t('delete'),
                        item: this.$t('campaign')
                    }))
                )
            })
        }
    },
    watch: {
        activeProject: {
            immediate: true,
            handler: function (activeProject) {
                if (activeProject) {
                    ConfigService.getConfigStepName().then(
                        result => {
                            if (result.data.length > 0) {
                                this.stepName = result.data[0].config_value
                            }
                        }
                    )
                }
            }
        }
    }
}
</script>

<style scoped>
    .form-text {
        width: 100%;
        max-width: 500px;
    }
</style>
